import { jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import { clsx } from '@flex-design-system/ve-presets';
import { Primitive } from '@radix-ui/react-primitive';
import { slotRootStyle } from './layout.vanilla.mjs';

const SlotRootImpl = ({
  className: classNameFromProps,
  ...props
}) => {
  const className = clsx(slotRootStyle, classNameFromProps);
  return /* @__PURE__ */ jsx(
    Primitive.div,
    {
      "data-scope": "slot-root",
      "data-part": "root",
      className,
      ...props
    }
  );
};
const Box = styled(Primitive.div);
const SlotRoot = styled(SlotRootImpl);
SlotRoot.toString = () => '[data-scope="slot-root"][data-part="root"]';

export { Box, SlotRoot };
//# sourceMappingURL=layout.mjs.map
